<template>
  <main v-if="recipe">
    <banner
      :title="recipe.title"
      :image="recipe.image.path_full"
    />

    <div class="container-fluid bg-white">
      <div class="container">
        <div class="row pt-3 pt-sm-5">
          <div class="col-12">
            <h5><em>Posted on <time>{{ recipe.created_at }}</time></em></h5>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-for="part in embeddedRecipeContentParts">
              <div
                v-if="part.type === 'text'"
                v-html="part.data"
              />
              <EmbeddedFoodRecipe
                v-else-if="part.type === 'food_recipe'"
                :data="part.data"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr>
            <div id="disqus_thread" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Recipes from '../services/recipes.js';
import EmbeddedFoodRecipe from "../components/EmbeddedFoodRecipe";

export default {
  components: {EmbeddedFoodRecipe},
  data () {
    return {
      recipe: null
    }
  },
  computed: {
    embeddedRecipeContentParts: function () {
      const splitCommands = {
        [Symbol.split](str, lim) {
          const regex = RegExp('(<p>)?\\s?<!-- embed:(\\w+):(\\S+) -->\\s?(</p>)?', 'gi');
          const results = [];
          let matches = [];
          let lastIndex = 0;

          while ((matches = regex.exec(str)) !== null) {
            const newLastIndex = regex.lastIndex;

            results.push({
              type: 'text',
              data: str.substring(lastIndex, newLastIndex - matches[0].length)
            });

            results.push({
              type: matches[2], // Embed type
              data: matches[3], // Embed data
            });

            lastIndex = newLastIndex;
          }

          results.push({
            type: 'text',
            data: str.substring(lastIndex),
          });

          return results;
        }
      };

      if (this.recipe.content) {
        return this.recipe.content.split(splitCommands);
      }

      return '';
    },
  },
  watch: {
    '$route.param.recipe': function (s) {
      this.fetchRecipe();
    },
  },
  mounted () {
    this.fetchRecipe();
  },
  methods: {
    fetchRecipe () {
      Recipes.get(this.$route.params.recipe).then(res => {
        this.recipe = res.data;
        window.scrollTo(0,0);
      });
    },
  },
}
</script>
